<template>
  <div id="app">
    <School></School>
  </div>
</template>

<script>
import School from '@/views/school/School.vue'
export default {
  components: {
    School
  }
}
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  outline: 0;
  box-sizing: border-box;
  // letter-spacing: 1px !important;
  // font-family: '-apple-system-font,BlinkMacSystemFont,"Helvetica Neue","PingFang SC","Hiragino Sans GB","Microsoft YaHei UI","Microsoft YaHei",Arial,sans-serif';
  font-family: "Arial","Microsoft YaHei","黑体","宋体",sans-serif;
}
#app {
}
</style>
